<ng-container *ngIf="myControlContainer.control as control">
    <ng-container *ngIf="!fieldTemplate; else customTemplate">
        <ng-container *ngIf="(control?.statusChanges | async) || {}">
            <div [id]="field.field + '_Item'" class="inputItem">
                <mat-form-field appearance="fill"
                                [color]="field.color"
                                [style.pointer-events]="control.disabled ? 'none' : null"
                                #item [style.z-index]="index">
                    <mat-label [class]="field.field + '_Label'">{{field.label | translate}}</mat-label>

                    <mat-date-range-input [formGroup]="control" [rangePicker]="picker" [dateFilter]="field.dateOptions?.dateFilter" [min]="field.dateOptions?.minDate || field.minDate" [max]="field.dateOptions?.maxDate || field.maxDate">
                        <input *ngIf="field.dateOptions?.dateFormats; else normalStartDate" [dateFormats]="field.dateOptions?.dateFormats"  matStartDate autocomplete="off" formControlName="start" [readonly]="field.readonly">
                        <input *ngIf="field.dateOptions?.dateFormats; else normalEndDate" [dateFormats]="field.dateOptions?.dateFormats"  matEndDate autocomplete="off" formControlName="end" [readonly]="field.readonly">
                        <ng-template #normalStartDate>
                            <input matStartDate autocomplete="off" formControlName="start" [readonly]="field.readonly">
                        </ng-template>
                        <ng-template #normalEndDate>
                            <input matEndDate autocomplete="off" formControlName="end" [readonly]="field.readonly">
                        </ng-template>
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker" [style.pointer-events]="field.readonly ? 'none' : 'inherit'"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker [touchUi]="field.touch" [dateClass]="field?.dateOptions?.dateClass"></mat-date-range-picker>
                    <div matSuffix class="matSuffix">
                        <button *ngIf="field.withClearButton" type="button" tabindex="-1" mat-icon-button (click)="$event.stopPropagation(); inputFormControl.patchValue({ start: '', end: '' })">
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-generic-input-slot [control]="control" [field]="field" [fieldAddonTemplates]="fieldAddonTemplates$ | async"></mat-generic-input-slot>
                    </div>
                    <mat-error *ngIf="!(field.selectSearchData?.selectData?.options | async)?.length">
                        <mat-generic-input-hint type="error" [control]="control" [field]="field" [item]="item"></mat-generic-input-hint>
                    </mat-error>
                    <mat-hint>
                        <mat-generic-input-hint type="combined" [control]="control" [field]="field" [item]="item"></mat-generic-input-hint>
                    </mat-hint>
                </mat-form-field>
                <mat-progress-bar class="loading" color="warning" mode="indeterminate"
                                  *ngIf="(control?.statusChanges | async) === 'PENDING' || control?.status === 'PENDING'"></mat-progress-bar>
            </div>
        </ng-container>
    </ng-container>

    <ng-template #customTemplate>
        <ng-container *ngTemplateOutlet="fieldTemplate.template, context: { $implicit: field, genericInput: this, formControl: control, index: index }"></ng-container>
    </ng-template>
</ng-container>
